/* @import '../../global/app.css'; */
@import '../../global/min-app.css';

:host {
  @apply selection:text-dark-blue selection:bg-logo-orange font-poppins;
  display: block;
}

.solution-card-container.pagination {
  @apply px-0 !important;
}

.center-content {
  @apply text-center mx-auto;
}


.card {
  @apply w-full  h-full relative flex flex-col items-start justify-between text-start flex-grow bg-ui-gray-6 rounded-xl;
}

.card-title {
  @apply fs-0 text-ui-gray-1  font-semibold line-clamp-3;
}

.card-category {
  @apply text-ui-gray-2 fs--1 mb-8px;
}

.card-location {
  @apply text-ui-gray-3 fs--1 py-8px;
}

.card-description {
  @apply text-ui-gray-2 fs--1 line-clamp-3 my-12px font-medium;
}

.card-description-wrapper {
  @apply p-16px w-full;
}

.card-description-wrapper.card-description-wrapper-medium {
  @apply py-20px;
}

.card-description-wrapper.card-description-wrapper-medium .card-title {
  @apply text-0 md:text-2 lg:text-2;
}

.card-description-wrapper.card-description-wrapper-medium .card-category {
  @apply text-0 md:text-1 lg:text-1;
}

.card-image-container {
  @apply w-full  aspect-square;
}

.card-image {
  @apply absolute w-full h-auto object-cover rounded-b-xl aspect-square;
}


.card-link {
  @apply absolute bottom-0 right-0 text-white bg-medium-blue p-4px rounded-xl h-32px w-32px flex items-center justify-center transition-colors hover:text-dark-blue;
}

.card-link::before {
  content: '';
  @apply w-8px h-8px bg-white rounded-full;
  mask-image: url('/wp-content/themes/3ecotheme/component-library/src/assets/general-icons/nav-icon-arrow.svg');
  mask-size: 100% 100%;
  mask-repeat: no-repeat;
}

.card-link.leadership {
  @apply bg-medium-blue;
}
.card-link.leadership::before {
  content: '';
  @apply w-16px h-16px bg-white rounded-none;
  mask-image: url('/wp-content/themes/3ecotheme/component-library/src/assets/nav-icons/social-linkedin.svg');
  mask-size: 100% 100%;
  mask-repeat: no-repeat;
}

.card:hover .card-link {
  @apply bg-dark-blue;
}

.card-overlay {
  @apply z-30 absolute top-0 left-0 w-full h-full cursor-pointer;
}

.solution-view-more-card {
  @apply min-w-[100px] flex flex-col items-center justify-center text-center flex-grow border border-ui-gray-4 hover:border-medium-blue transition-colors  rounded-xl relative bg-white;
}

.card-overlay:hover .solution-view-more-card {
  @apply border-medium-blue;
}

.card-overlay:hover .card {
  @apply bg-ui-gray-5;
}

.cards-wrapper {
  @apply grid grid-cols-2 w-full gap-24px sm:gap-16px md:gap-20px lg:gap-32px grid-rows-1;
}

.cards-wrapper.card-wrapper-wide-gap {
  @apply gap-24px md:gap-[58px] lg:gap-[70px];
}

.cards-wrapper.layout-author .card {
  @apply md:col-span-9;
}

.layout-6 {
  @apply sm:grid-cols-3  md:grid-cols-6;
}

.layout-5 {
  @apply sm:grid-cols-3  md:grid-cols-5;
}

.layout-4 {
  @apply sm:grid-cols-5  md:grid-cols-12;
}

.layout-4 .card {
  @apply md:col-span-3 col-span-1;
}

.layout-4 .solution-view-more-card {
  @apply max-sm:col-span-full;
}

@media(min-width: 1000px) {
  .layout-4 {
    grid-template-columns: repeat(13, 1fr);
  }

  .layout-4 .card {
    @apply col-span-3;
  }
  
  .layout-4 .card:nth-child(4n+5) {
    @apply col-span-1 flex flex-col justify-center items-center max-w-[150px] text-center;
  }
}

.pagination-cards-wrapper {
  @apply pt-0 !important;
}

.layout-leadership {
  @apply grid-cols-3 sm:grid-cols-6  md:grid-cols-12 grid-rows-1;
  grid-template-rows: 1fr;
}

.layout-leadership .card {
  @apply col-span-3;
}

.layout-pagination {
  @apply sm:grid-cols-3  md:grid-cols-12 grid-rows-1;
  grid-template-rows: 1fr;
}

.layout-pagination .card {
  @apply col-span-1 md:col-span-4;
}

.layout-jobs {
  @apply grid-cols-6  md:grid-cols-12 grid-rows-1;
  grid-template-rows: 1fr;

}

.layout-jobs .card {
  @apply col-span-3 md:col-span-4;
}

.layout-3 {
  @apply sm:grid-cols-4  md:grid-cols-10;
}

.layout-3 .card {
  @apply col-span-1 md:col-span-3;
}

.layout-3 .card:last-child {
  @apply col-span-1 max-w-[225px] flex flex-col justify-center items-center text-center;
}

.layout-2 .card .card-image-container img {
  @apply rounded-r-xl rounded-l-none h-full;
}

.layout-2 {
  @apply sm:grid-cols-7  md:grid-cols-9;
}

.layout-2 .card {
  @apply flex-row col-span-3 md:col-span-4 h-[225px];
}

.layout-2 .card .card-image-container {
  @apply h-[225px] w-full;
}

.layout-2 .card:last-child {
  @apply col-span-3 sm:col-span-1 sm:max-w-[225px] flex flex-col justify-center items-center text-center;
}
/* Author */
.container-1 {
  @apply px-0 md:pr-32px md:pl-0 py-64px;
}
.layout-1 {
  @apply grid-cols-4  md:grid-cols-9 ml-auto;
}

.layout-1 .card {
  @apply col-span-4  md:col-span-8 flex-row md:max-h-[600px] overflow-hidden rounded-[12px];
}

.layout-1 .card .card-title {
  @apply fs-4;
}

.layout-1 .card .card-description {
  @apply fs-1;
}

.layout-1 .card .card-description-wrapper {
  @apply p-12px md:p-48px w-full;
}

.layout-1 .card .card-description-wrapper .card-description {
  @apply line-clamp-1  sm:line-clamp-2;
}
.layout-1 .card .card-description-wrapper .card-title {
  @apply normal-case h-auto mb-8px;
}
.layout-1 .card .card-image-container {
  @apply h-full w-full max-w-full;
}

.layout-1 .card .card-image-container img {
  @apply rounded-r-xl rounded-l-none max-w-full;
}

.layout-1 .solution-view-more-card {
  @apply max-sm:col-span-full;
}
/* Linedin Btn */

.layout-1 .linkedin-btn {
  @apply w-fit  my-8px md:my-16px cursor-pointer block px-16px py-8px fs-1 font-medium rounded border-2 border-medium-blue transition-colors text-medium-blue hover:border-dark-blue hover:text-dark-blue text-center;
}
/* .layout-1 .card:last-child {
  @apply col-span-4 sm:col-span-1 sm:max-w-[225px] flex flex-col justify-center items-center text-center;
} */


/* Animation fadeIn */
@keyframes fade-in {
  0% {
    opacity: 0.40;
  }
  100% {
    opacity: 0;
  }
}

.overlay1, .overlay2, .overlay3, .overlay4, .overlay5, .overlay6{
  @apply bg-white absolute w-full h-full top-0 left-0 z-10 opacity-50;
  /* filter: grayscale(100%); */
  animation-fill-mode: forwards;
  animation-timing-function: ease-in-out;
  animation-duration: 200ms;
}

.cards-wrapper.animate .overlay1 {
    animation-name: fade-in;
    animation-delay: 0s;
  }
  
.cards-wrapper.animate .overlay2 {
  animation-name: fade-in;
  animation-delay: .05s;
}

.cards-wrapper.animate .overlay3 {
  animation-name: fade-in;
  animation-delay: 0.1s;
}

.cards-wrapper.animate .overlay4 {
  animation-name: fade-in;
  animation-delay: 0.15s;
}

.cards-wrapper.animate .overlay5 {
  animation-name: fade-in;
  animation-delay: 0.2s;
}

.cards-wrapper.animate .overlay6 {
  animation-name: fade-in;
  animation-delay: 0.25s;
}



